export interface TurkeyProvince {
  plate: number;
  name: string;
  aliases: string[];
}

const normalizeTr = (value?: string): string =>
  String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'i')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');

export const TURKEY_PROVINCES: TurkeyProvince[] = [
  { plate: 1, name: 'Adana', aliases: [] },
  { plate: 2, name: 'Adıyaman', aliases: ['adiyaman'] },
  { plate: 3, name: 'Afyonkarahisar', aliases: ['afyon'] },
  { plate: 4, name: 'Ağrı', aliases: ['agri'] },
  { plate: 5, name: 'Amasya', aliases: [] },
  { plate: 6, name: 'Ankara', aliases: [] },
  { plate: 7, name: 'Antalya', aliases: [] },
  { plate: 8, name: 'Artvin', aliases: [] },
  { plate: 9, name: 'Aydın', aliases: ['aydin'] },
  { plate: 10, name: 'Balıkesir', aliases: ['balikesir'] },
  { plate: 11, name: 'Bilecik', aliases: [] },
  { plate: 12, name: 'Bingöl', aliases: ['bingol'] },
  { plate: 13, name: 'Bitlis', aliases: [] },
  { plate: 14, name: 'Bolu', aliases: [] },
  { plate: 15, name: 'Burdur', aliases: [] },
  { plate: 16, name: 'Bursa', aliases: [] },
  { plate: 17, name: 'Çanakkale', aliases: ['canakkale'] },
  { plate: 18, name: 'Çankırı', aliases: ['cankiri'] },
  { plate: 19, name: 'Çorum', aliases: ['corum'] },
  { plate: 20, name: 'Denizli', aliases: [] },
  { plate: 21, name: 'Diyarbakır', aliases: ['diyarbakir'] },
  { plate: 22, name: 'Edirne', aliases: [] },
  { plate: 23, name: 'Elazığ', aliases: ['elazig'] },
  { plate: 24, name: 'Erzincan', aliases: [] },
  { plate: 25, name: 'Erzurum', aliases: [] },
  { plate: 26, name: 'Eskişehir', aliases: ['eskisehir'] },
  { plate: 27, name: 'Gaziantep', aliases: ['antep'] },
  { plate: 28, name: 'Giresun', aliases: [] },
  { plate: 29, name: 'Gümüşhane', aliases: ['gumushane'] },
  { plate: 30, name: 'Hakkari', aliases: [] },
  { plate: 31, name: 'Hatay', aliases: ['antakya'] },
  { plate: 32, name: 'Isparta', aliases: [] },
  { plate: 33, name: 'Mersin', aliases: ['icel'] },
  { plate: 34, name: 'İstanbul', aliases: ['istanbul', 'ist'] },
  { plate: 35, name: 'İzmir', aliases: ['izmir'] },
  { plate: 36, name: 'Kars', aliases: [] },
  { plate: 37, name: 'Kastamonu', aliases: [] },
  { plate: 38, name: 'Kayseri', aliases: [] },
  { plate: 39, name: 'Kırklareli', aliases: ['kirklareli'] },
  { plate: 40, name: 'Kırşehir', aliases: ['kirsehir'] },
  { plate: 41, name: 'Kocaeli', aliases: ['izmit'] },
  { plate: 42, name: 'Konya', aliases: [] },
  { plate: 43, name: 'Kütahya', aliases: ['kutahya'] },
  { plate: 44, name: 'Malatya', aliases: [] },
  { plate: 45, name: 'Manisa', aliases: [] },
  { plate: 46, name: 'Kahramanmaraş', aliases: ['maras', 'kahramanmaras'] },
  { plate: 47, name: 'Mardin', aliases: [] },
  { plate: 48, name: 'Muğla', aliases: ['mugla'] },
  { plate: 49, name: 'Muş', aliases: ['mus'] },
  { plate: 50, name: 'Nevşehir', aliases: ['nevsehir'] },
  { plate: 51, name: 'Niğde', aliases: ['nigde'] },
  { plate: 52, name: 'Ordu', aliases: [] },
  { plate: 53, name: 'Rize', aliases: [] },
  { plate: 54, name: 'Sakarya', aliases: ['adapazari', 'adapazarı'] },
  { plate: 55, name: 'Samsun', aliases: [] },
  { plate: 56, name: 'Siirt', aliases: [] },
  { plate: 57, name: 'Sinop', aliases: [] },
  { plate: 58, name: 'Sivas', aliases: [] },
  { plate: 59, name: 'Tekirdağ', aliases: ['tekirdag'] },
  { plate: 60, name: 'Tokat', aliases: [] },
  { plate: 61, name: 'Trabzon', aliases: [] },
  { plate: 62, name: 'Tunceli', aliases: [] },
  { plate: 63, name: 'Şanlıurfa', aliases: ['urfa', 'sanliurfa'] },
  { plate: 64, name: 'Uşak', aliases: ['usak'] },
  { plate: 65, name: 'Van', aliases: [] },
  { plate: 66, name: 'Yozgat', aliases: [] },
  { plate: 67, name: 'Zonguldak', aliases: [] },
  { plate: 68, name: 'Aksaray', aliases: [] },
  { plate: 69, name: 'Bayburt', aliases: [] },
  { plate: 70, name: 'Karaman', aliases: [] },
  { plate: 71, name: 'Kırıkkale', aliases: ['kirikkale'] },
  { plate: 72, name: 'Batman', aliases: [] },
  { plate: 73, name: 'Şırnak', aliases: ['sirnak'] },
  { plate: 74, name: 'Bartın', aliases: ['bartin'] },
  { plate: 75, name: 'Ardahan', aliases: [] },
  { plate: 76, name: 'Iğdır', aliases: ['igdir'] },
  { plate: 77, name: 'Yalova', aliases: [] },
  { plate: 78, name: 'Karabük', aliases: ['karabuk'] },
  { plate: 79, name: 'Kilis', aliases: [] },
  { plate: 80, name: 'Osmaniye', aliases: [] },
  { plate: 81, name: 'Düzce', aliases: ['duzce'] },
];

const aliasToProvince = (() => {
  const map = new Map<string, TurkeyProvince>();
  TURKEY_PROVINCES.forEach((province) => {
    map.set(normalizeTr(province.name), province);
    map.set(String(province.plate), province);
    province.aliases.forEach((alias) => map.set(normalizeTr(alias), province));
  });
  return map;
})();

export const resolveTurkeyProvince = (value?: string): TurkeyProvince | null => {
  const key = normalizeTr(value);
  if (!key) return null;
  return aliasToProvince.get(key) || null;
};

export const TURKEY_PROVINCE_NAMES = TURKEY_PROVINCES.map((p) => p.name);
